import { render } from "./Pagination.vue?vue&type=template&id=6021eb60"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"
script.render = render

export default script